import {
  Button,
  Field,
  Link,
  Menu,
  MenuItemCheckbox,
  MenuList,
  MenuPopover,
  MenuTrigger,
  Spinner,
  tokens,
} from "@fluentui/react-components";
import _ from "lodash";
import { memo, useCallback, useMemo } from "react";
import SyncIcon from "~icons/material-symbols/sync";
import { workspaceApi } from "../../../services/workspaces";
import { useWorkspaceMenuSelectorStyles } from "../styles/WorkspaceMenuSelector.styles";

type WorkspaceMenuSelectorProps = {
  value: string;
  onChange: (value: string) => void;
};

export const WorkspaceMenuSelector = memo(({ value, onChange }: WorkspaceMenuSelectorProps) => {
  const styles = useWorkspaceMenuSelectorStyles();
  const { data: workspaces = [], isLoading, refetch, isFetching } = workspaceApi.useGetWorkspacesQuery();

  const selectedWorkspace = useMemo(() => {
    if (isLoading) return {};
    if (_.isEmpty(workspaces)) return {};
    const w = _.find(workspaces, { workspaceId: value });
    if (!w) return { [workspaces[0].name]: [workspaces[0].workspaceId] };
    return { [w!.name]: [w!.workspaceId] };
  }, [workspaces, value, isLoading]);

  const refreshWorkspaces = useCallback(async () => {
    await refetch().unwrap();
  }, [refetch]);
  const handleCheckedValueChange = useCallback(
    (_ev, data) => {
      onChange(data.checkedItems[0]);
    },
    [onChange]
  );

  return (
    <Field className={styles.container}>
      Searching in workspace{" "}
      <Menu positioning={"below"} checkedValues={selectedWorkspace} onCheckedValueChange={handleCheckedValueChange}>
        <MenuTrigger disableButtonEnhancement>
          <Link inline disabled={isFetching || isLoading} className={styles.link}>
            {isLoading && "Loading Workspaces..."}
            {!isLoading && Object.keys(selectedWorkspace)[0]}
          </Link>
        </MenuTrigger>
        <MenuPopover className={styles.menuPopover}>
          <MenuList>
            {workspaces?.map((w) => (
              <MenuItemCheckbox key={w.workspaceId} name={w.name} value={w.workspaceId}>
                {w.name}
              </MenuItemCheckbox>
            ))}
          </MenuList>
        </MenuPopover>
      </Menu>
      {isFetching && <Spinner size="extra-tiny" />}
      {!isFetching && (
        <Button
          size="small"
          appearance="transparent"
          icon={<SyncIcon color={tokens.colorBrandBackground} />}
          onClick={refreshWorkspaces}
        />
      )}
    </Field>
  );
});
